/** Viewport width below which mobile full-bleed overlays and chrome insets apply. */

export const MOBILE_NPC_OVERLAY_BREAKPOINT = 720;

export function isMobileNpcOverlay(vw: number): boolean {
  return vw < MOBILE_NPC_OVERLAY_BREAKPOINT;
}
